'use client'

import { useEffect } from 'react'
import { Button } from '@repo/ui/button'
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@repo/ui/card'
import { logger } from '../lib/logger'

export default function ErrorComponent({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Log the route-level error using our common logger
    logger.error(
      'Next.js Route Error', 
      error, 
      'next_client_exception',
      {
        digest: error.digest,
        // Any additional context that might be helpful
        route_level: true,
        recoverable: true
      }
    )
  }, [error])

  return (
    <div className="flex items-center justify-center p-4 min-h-[50vh]">
      <Card className="w-full max-w-lg">
        <CardHeader>
          <CardTitle className="text-2xl text-center">Application Error</CardTitle>
          <CardDescription className="text-center">
            We've encountered an unexpected error. This has been automatically reported to our team.
          </CardDescription>
        </CardHeader>
        <CardContent className="text-center space-y-4">
          {process.env.NODE_ENV === 'development' && (
            <div className="p-4 bg-destructive/10 rounded text-left overflow-auto text-sm">
              <p className="font-semibold">{error.name}: {error.message}</p>
              {error.stack && (
                <pre className="mt-2 text-xs whitespace-pre-wrap break-all">
                  {error.stack}
                </pre>
              )}
            </div>
          )}
        </CardContent>
        <CardFooter className="flex flex-col gap-2 justify-center pb-6">
          <Button onClick={reset} size="lg" className="min-w-32">
            Try again
          </Button>
          <Button 
            onClick={() => window.location.reload()} 
            variant="outline"
            size="lg"
            className="min-w-32"
          >
            Reload page
          </Button>
        </CardFooter>
      </Card>
    </div>
  )
} 